import XmlTesterComponent from "../../modules/xml-tester/xml-tester";

export default function XMLTester() {
    return <XmlTesterComponent role="organization" />;
}